import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Maximize2, Minimize2 } from 'lucide-react';

const WidgetModal = ({ isOpen, onClose, children }) => {
  const [isMaximized, setIsMaximized] = useState(false);
  return (
    <AnimatePresence>
      {isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          perspective: '1000px'
        }}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(10px)'
            }}
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -20 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            style={{
              position: 'relative',
              width: isMaximized ? '100vw' : '90vw',
              maxWidth: isMaximized ? 'none' : '1200px',
              height: isMaximized ? '100vh' : '85vh',
              maxHeight: isMaximized ? 'none' : '92vh',
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(40px)',
              border: isMaximized ? '1px solid transparent' : '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: isMaximized ? '0' : '24px',
              boxShadow: '0 24px 60px rgba(0, 0, 0, 0.4)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              color: '#fff',
              transition: 'all 0.3s ease-in-out'
            }}
          >
            {/* Fixed Header Area */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 20px 10px 40px',
              flexShrink: 0
            }}>
              {/* Optional dynamic title slot could be injected here. We rely on children to render title below if needed, or we can pass a title prop later. */}
              <div></div>
              
              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{
                  cursor: 'pointer',
                  padding: '8px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s'
                }} onClick={() => setIsMaximized(!isMaximized)}
                   title={isMaximized ? "还原" : "最大化"}
                   onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                   onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
                >
                  {isMaximized ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
                </div>
                <div style={{
                  cursor: 'pointer',
                  padding: '8px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s'
                }} onClick={onClose}
                   title="关闭"
                   onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                   onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
                >
                  <X size={20} />
                </div>
              </div>
            </div>

            {/* Scrollable Content Area */}
            <div className="custom-scrollbar" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
              {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                  return React.cloneElement(child, { isMaximized });
                }
                return child;
              })}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default WidgetModal;
